import React from "react";
import { makeStyleguideTemplate } from "tsi-common-react/src/styleguide/makeStyleguideTemplate";

import { templates } from "@reactivated";

import { toolboxComponentsMap } from "../blocks/toolboxComponentsMap";
import { homePageComponentsMap } from "../components/HomePageBody";
import { homeEmailSignupComponentsMap } from "../components/HomePageEmailSignup";
import { heroCarouselComponentsMap } from "../components/HomePageHeroCarousel";
import { buildLandingBottomComponentsMap } from "../components/LandingPageBodyBottom";
import { productDisplayPageBodyComponentsMap } from "../components/ProductDisplayPageBody";
import { StyleguideChrome } from "../components/StyleguideChrome";
import { utilityComponentsMap } from "../components/UtilityPageBody";

// The LandingPage bottom map's only page-derived input is the review anchor's
// `href`; the sole fixture routed through it (ThreeByThreeImageBlock) carries
// all its content in the serialized value, so a zeroed pdpUrl ("" -> `#reviews`)
// is render-faithful. See buildLandingBottomComponentsMap.
const landingBottomComponentsMap = buildLandingBottomComponentsMap("");

const registry = {
    toolbox: toolboxComponentsMap,
    home: homePageComponentsMap,
    pdp: productDisplayPageBodyComponentsMap,
    utility: utilityComponentsMap,
    home_hero_carousel: heroCarouselComponentsMap,
    home_email_signup: homeEmailSignupComponentsMap,
    landing_bottom: landingBottomComponentsMap,
};

const StyleguideBlocks = makeStyleguideTemplate(registry);

export const Template = (
    props: templates.StyleguideBlockTemplate,
): React.JSX.Element => {
    const inner = (
        <StyleguideBlocks
            block={props.block}
            map_key={props.map_key}
            bg_color={props.bg_color}
        />
    );
    return (
        <StyleguideChrome storybook={props.storybook}>
            {props.storybook ? inner : <div id="block-tester">{inner}</div>}
        </StyleguideChrome>
    );
};
